<template>
  <NuxtPwaManifest />
  <PwaRefresh />
  <NuxtLoadingIndicator color="#f15a48" />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
